import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
// require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';


$(document).foundation();

$('.menu-open').click(function(e){
    e.preventDefault();
    $('#menu').foundation('open');
});

$('.courses-open').click(function(e){
    e.preventDefault();
    $('#coursesMenu').foundation('open');
});

$(document).ready(function(){

    // Site-wide Smooth Scroll
    $('a[href*="\\#"]').click(function(e){
        if (e.target > 1) {
            let dest = $(e.target).attr('href');

            $('html,body').animate({
                scrollTop: $(dest).offset().top - 135
            });
        }
    });

    const triggerThreshold = 0.2;

    // Visibility classes for animation
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('anim__view');
                } else {
                    entry.target.classList.add('anim__prime');
                }
            });
        },
        {
            threshold: triggerThreshold
        }
    );

    const tags = document.querySelectorAll('section > *, .bottom-content > *, footer');

    tags.forEach((tag) => {
        observer.observe(tag);
        // Check if element is already in viewport
        const rect = tag.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        
        // Calculate visible height of the element
        const visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
        
        // Calculate what percentage of the viewport is occupied by the element
        const viewportOccupancy = visibleHeight / viewportHeight;
        
        // Apply class if viewport occupancy meets the minimum threshold
        if (viewportOccupancy > 0.1) {
            tag.classList.add('anim__view');
        }
    });
});
